import { render, staticRenderFns } from "./ImageQA.vue?vue&type=template&id=547f3ad6&scoped=true"
import script from "./ImageQA.vue?vue&type=script&lang=js"
export * from "./ImageQA.vue?vue&type=script&lang=js"
import style0 from "./ImageQA.vue?vue&type=style&index=0&id=547f3ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f3ad6",
  null
  
)

export default component.exports